
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"currentColor","stroke-width":"1.25","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M8.75 3.125V7.5m10.623 10.063L18.167 1.204a.625.625 0 00-.623-.579H2.456a.624.624 0 00-.623.583L.627 17.563a.625.625 0 00.513.661l6.36 1.141a.626.626 0 00.727-.513l1.044-6.36a.737.737 0 011.453 0l1.044 6.36c.056.34.378.57.719.514h.008l6.363-1.142a.625.625 0 00.515-.66zm-1.07-14.438H1.697m9.553 0V7.5"}}),_c('path',{attrs:{"d":"M1.307 8.577A5 5 0 004.96 3.125H1.697l-.39 5.452zm17.385 0a5 5 0 01-3.654-5.452h3.265l.39 5.452z"}})])])
          )
        }
      }
    